import React from 'react';
import Modal from 'react-responsive-modal';
import { Link } from 'react-router-dom';
import TsSprintDetail from './TsSprintDetail.jsx';

class TsSprintItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			backgroundImage: false,
		};
	}

	// Si le composant va être utilisé
	componentWillMount() {
		this.setState({
			backgroundImage: 'https://source.unsplash.com/240x150/?sig=' + this.props.sprintInfo.number + '&computer',
		});
	}

	render () {
		return (
			<Link 
				to={`/sprints/${this.props.sprintInfo.apiId}/${this.props.sprintInfo.number}`}
				className="not-a-like"
			>
				<div className="sprintItem txtwhite txtcenter ptm transition-fast pointer"
					style={{backgroundImage: 'url(' + this.state.backgroundImage + ')'}} >

					<h2 className="proxima-bold man">Sprint {this.props.sprintInfo.number}</h2>
					<h6 className="man">{this.props.sprintInfo.version} - {this.props.sprintInfo.numberOfCards} cartes</h6>
				</div>
			</Link>
		);
	}
}

export default TsSprintItem;


// WEBPACK FOOTER //
// ./src/js/TsSprintItem.jsx